// src/views/Loginpage.jsx - CORRIGÉ
import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import Footer from "../components/Footer";
import PublicTopBar from "./PublicTopBar";

export default function Loginpage() {
  const { loginUser } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!username.trim() || !password.trim()) {
      setError("Veuillez remplir tous les champs.");
      return;
    }

    setLoading(true);
    try {
      await loginUser(username, password);
    } catch (err) {
      setError("Identifiants incorrects. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        :root {
          --n-bg:    #f8f9fa;
          --n-card:  #ffffff;
          --n-ink:   #0f1b2d;
          --n-mut:   #64748b;
          --n-b:     #e8e8ee;
          --n-b2:    #d0d0da;

          --lg-primary:   #004080;
          --lg-primary-h: #003166;
        }

        .lg-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background: var(--n-bg);
        }

        .lg-section {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 120px 16px 40px;
        }

        .lg-card {
          background: var(--n-card);
          border-radius: 16px;
          padding: 32px 28px;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 1rem 3rem rgba(0,0,0,.12);
          animation: lg-fade-in .6s ease;
        }

        @keyframes lg-fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .lg-title {
          font-weight: 700;
          font-size: 22px;
          color: var(--lg-primary);
          text-align: center;
          margin-bottom: 4px;
        }

        .lg-subtitle {
          font-size: 14px;
          color: var(--n-mut);
          text-align: center;
          margin-bottom: 24px;
        }

        .lg-error {
          background: #fcebeb; color: #a32d2d;
          border-radius: 7px; padding: 9px 12px;
          font-size: 13px; margin-bottom: 16px;
        }

        .lg-field { margin-bottom: 16px; }

        .lg-label {
          display: block; font-size: 14px; font-weight: 600;
          color: var(--n-mut); margin-bottom: 6px;
        }

        .lg-input-wrap { position: relative; display: flex; }

        .lg-input {
          width: 100%;
          padding: 10px 14px;
          border: 1px solid var(--n-b2);
          border-radius: 8px;
          font-size: 15px;
          font-family: inherit;
          outline: none;
          box-sizing: border-box;
          color: var(--n-ink);
          background: var(--n-card);
          transition: box-shadow .2s ease;
        }
        .lg-input:focus {
          box-shadow: 0 0 0 0.25rem rgba(0, 64, 128, 0.25);
        }
        .lg-input.pw { padding-right: 42px; border-radius: 8px; }

        .lg-eye {
          position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
          background: none; border: none; cursor: pointer;
          color: var(--n-mut); font-size: 17px; padding: 4px;
          display: flex; align-items: center;
        }
        .lg-eye:hover { color: var(--n-ink); }

.lg-btn {
  width: 100%;
  padding: 12px;
  background: var(--lg-primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  margin-top: 6px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .15s ease, opacity .15s ease;
}
        .lg-btn:hover:not(:disabled) { background: var(--lg-primary-h); }
        .lg-btn:disabled { opacity: .65; cursor: default; }

        .lg-forgot {
          text-align: center;
          margin-top: 14px;
        }
        .lg-forgot a {
          color: var(--lg-primary);
          font-size: 13.5px;
          font-weight: 600;
          text-decoration: none;
        }
        .lg-forgot a:hover { text-decoration: underline; }

        .lg-links {
          display: flex;
          justify-content: center;
          gap: 16px;
          margin-top: 16px;
          flex-wrap: wrap;
        }

        .lg-links a {
          color: var(--n-mut);
          font-size: 13px;
          text-decoration: none;
          transition: color .2s ease;
        }

        .lg-links a:hover {
          color: var(--lg-primary);
          text-decoration: underline;
        }

        .lg-links .separator {
          color: var(--n-b2);
        }

        @media (max-width: 768px) {
          .lg-section {
            padding: 100px 16px 30px;
          }
        }

        @media (max-width: 480px) {
          .lg-section {
            padding: 90px 12px 20px;
          }
          .lg-card {
            padding: 24px 18px;
          }
        }
      `}</style>

      <div className="lg-page">
        <PublicTopBar />

        <div className="lg-section">
          <div className="lg-card">
            <div className="lg-title">Bon retour 👋</div>
            <div className="lg-subtitle">Connectez-vous à votre compte</div>

            {error && <div className="lg-error">{error}</div>}

            <form onSubmit={handleSubmit} noValidate>
              <div className="lg-field">
                <label className="lg-label">
                  Numéro de téléphone ou nom d'utilisateur
                </label>
                <input
                  className="lg-input"
                  type="text"
                  placeholder="Entrez votre nom d'utilisateur"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  autoFocus
                  required
                />
              </div>

              <div className="lg-field">
                <label className="lg-label">Mot de passe</label>
                <div className="lg-input-wrap">
                  <input
                    className="lg-input pw"
                    type={showPassword ? "text" : "password"}
                    placeholder="Entrez votre mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <button
                    type="button"
                    className="lg-eye"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={
                      showPassword
                        ? "Masquer le mot de passe"
                        : "Afficher le mot de passe"
                    }
                  >
                    <i
                      className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"}`}
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </div>

              <button type="submit" className="lg-btn" disabled={loading}>
                {loading ? "Connexion..." : "Se connecter"}
              </button>
            </form>

            <div className="lg-forgot">
              <Link to="/mot-de-passe-oublier">Mot de passe oublié ?</Link>
            </div>

            {/* <div className="lg-links">
              <Link to="/features">Fonctionnalités</Link>
              <span className="separator">|</span>
              <Link to="/demo">Voir la démo</Link>
              <span className="separator">|</span>
              <Link to="/contact">Nous contacter</Link>
            </div> */}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}